import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPartiesLedgerFetch, selectLedgerFilter, selectPartyLedger } from '../../Redux/slices/partyState'
import { getDateString } from '../../Utils/GetTimeStamp'
import LedgerFilterBar from './LedgerFilterBar'
export default function PartyTransactionRecord({partyId=false}) {
    const summary = {
        totalAmount:0,
    }
    const dispatch = useDispatch()
    const records = useSelector(selectPartyLedger)
    const filter = useSelector(selectLedgerFilter)
    useEffect(() => {
    if(partyId) dispatch(getPartiesLedgerFetch(partyId))
    
      
      return () => {
        
      }
    }, [dispatch,partyId,filter])
    
    return (
        <>
        <LedgerFilterBar/>
        <div id='transactionTable' className="flex flex-col my-6 ">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-full table-auto border-spacing-2 border-collapse border-b border-x-2 border-t-2  text-center shadow-md">
                            <thead className='bg-sky-500 text-white'>
                                <tr >
                                    <th className='p-3  whitespace-nowrap rounded-tl-md'>Sr. No</th>
                                    <th className='p-3  whitespace-nowrap'>Date</th>
                                    <th className='p-3  whitespace-nowrap'>Amount</th>
                                    <th className='p-3  whitespace-nowrap'>Payment Mode</th>
                                    <th className='p-3  whitespace-nowrap'>Remark</th>
                                </tr>
                            </thead>
                            <tbody className='divide-y'>
                               {records&&records.map((t,i)=>{
                                calculateSummary(summary,t)
                                return <TableRow {...t} sr_no={i} data={t} key={t.docid}  />
                               
                               })} 
                                {true&&<SummaryRow  key={"summary"} {...summary} length={records.length} unit={"trip"} />}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

function TableRow({sr_no,date,paid,payment_type,remark}) {
   
        //console.log({docid,selectedDocId})
    return (
        <tr className={`hover:bg-gray-100 cursor-pointer`}>
            <td className='p-3  whitespace-nowrap'>{sr_no+1}</td>
            <td className='p-3  whitespace-nowrap'>{getDateString(date)}</td>
            <td className='p-3  whitespace-nowrap'>{paid}</td>
            <td className='p-3  whitespace-nowrap'>{payment_type}</td>
            <td className='p-3  whitespace-nowrap'>{remark}</td>
        </tr>
    )
}
function SummaryRow({length=0,totalAmount=0,}){
    return (
        <tr  className={`bg-gray-200 cursor-pointer`}>
            <td className='py-3  whitespace-nowrap'>{length}</td>
            <td className='py-3  whitespace-nowrap'>{" "}</td>
            <td className='py-3  whitespace-nowrap font-medium'>{totalAmount}</td>
            <td className='py-3  whitespace-nowrap font-bold text-right'>{" "}</td>
            <td className='py-3  whitespace-nowrap font-medium'>{" "}</td>
        </tr>
        )
}
function calculateSummary(summary,t){
    summary.totalAmount= summary.totalAmount +parseInt(t.paid)
}
